import { createRouter, createWebHistory } from 'vue-router'

// 1. 必须引入对应的 Vue 组件文件
// 请确保路径 '@/views/...' 与你实际文件位置一致
import ProductVideoPage from '@/views/ProductVideoPage.vue'
import WelcomeImageGenerator from '@/views/WelcomeImageGenerator.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: ProductVideoPage, // 首页显示视频页面
    meta: { 
      title: '金鹏烟花' 
    }
  },
  
  // --- 产品视频页面路由 (可选，如果首页就是视频页，这个可以保留作为备用路径) ---
  {
    path: '/product-video', 
    name: 'ProductVideo',
    component: ProductVideoPage,
    meta: { 
      title: '产品视频展示' 
    }
  },

  // --- 欢迎图片生成页面路由 ---
  {
    path: '/welcome-image', 
    name: 'WelcomeImage',
    component: WelcomeImageGenerator,
    meta: {
      title: '欢迎图片生成'
    }
  }
]

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 History 模式
  routes
})

// 全局前置守卫：动态设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router